import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { BusinessProvider } from './context/BusinessContext';
import ProfilePage from './pages/ProfilePage';
import RedirectToMennu from './components/RedirectToMennu';
import './App.css';

function App() {
  return (
    <Router>
      <BusinessProvider>
        <Routes>
          {/* Route for specific business slug */}
          <Route path="/:slug" element={<ProfilePage />} />
          {/* Redirect root to mennu.mx */}
          <Route path="/" element={<RedirectToMennu />} />
        </Routes>
      </BusinessProvider>
    </Router>
  );
}

export default App;
